module.exports = __webpack_public_path__ + "img/Tonga.6344778b.gif";